export var IconName;
(function (IconName) {
    IconName[IconName["add"] = 0] = "add";
    IconName[IconName["airplay"] = 1] = "airplay";
    IconName[IconName["all_channels"] = 2] = "all_channels";
    IconName[IconName["all_channels_rtl"] = 3] = "all_channels_rtl";
    IconName[IconName["all_episodes"] = 4] = "all_episodes";
    IconName[IconName["audio_subtitles"] = 5] = "audio_subtitles";
    IconName[IconName["back"] = 6] = "back";
    IconName[IconName["check"] = 7] = "check";
    IconName[IconName["close"] = 8] = "close";
    IconName[IconName["confirm"] = 9] = "confirm";
    IconName[IconName["edit"] = 10] = "edit";
    IconName[IconName["enterfullscreen"] = 11] = "enterfullscreen";
    IconName[IconName["exitfullscreen"] = 12] = "exitfullscreen";
    IconName[IconName["forward_10"] = 13] = "forward_10";
    IconName[IconName["geoblock"] = 14] = "geoblock";
    IconName[IconName["gotolive"] = 15] = "gotolive";
    IconName[IconName["info"] = 16] = "info";
    IconName[IconName["navigatenext"] = 17] = "navigatenext";
    IconName[IconName["navigateprev"] = 18] = "navigateprev";
    IconName[IconName["pause"] = 19] = "pause";
    IconName[IconName["play"] = 20] = "play";
    IconName[IconName["quality"] = 21] = "quality";
    IconName[IconName["remove"] = 22] = "remove";
    IconName[IconName["restart"] = 23] = "restart";
    IconName[IconName["rewind_10"] = 24] = "rewind_10";
    IconName[IconName["settings"] = 25] = "settings";
    IconName[IconName["skipnext"] = 26] = "skipnext";
    IconName[IconName["skipprev"] = 27] = "skipprev";
    IconName[IconName["spinner"] = 28] = "spinner";
    IconName[IconName["subpage"] = 29] = "subpage";
    IconName[IconName["volume_0"] = 30] = "volume_0";
    IconName[IconName["volume_100"] = 31] = "volume_100";
    IconName[IconName["volume_50"] = 32] = "volume_50";
    IconName[IconName["volume_off"] = 33] = "volume_off";
})(IconName || (IconName = {}));
//# sourceMappingURL=sharedEnums.js.map